var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(123 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(-123 2)",
    fill: "#868686"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 20 10C 20 10.4804 19.6109 10.8696 19.1304 10.8696L 10.8696 10.8696L 10.8696 19.1304C 10.8696 19.6104 10.4804 20 10 20C 9.51956 20 9.13043 19.6104 9.13043 19.1304L 9.13043 10.8696L 0.869565 10.8696C 0.38913 10.8696 0 10.4804 0 10C 0 9.51956 0.38913 9.13043 0.869565 9.13043L 9.13043 9.13043L 9.13043 0.869565C 9.13043 0.38913 9.51956 0 10 0C 10.4804 0 10.8696 0.38913 10.8696 0.869565L 10.8696 9.13043L 19.1304 9.13043C 19.6109 9.13043 20 9.51956 20 10Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.ca9dca0a8f19d873f6331c57c5442634.svg";
export { ForwardRef as ReactComponent };